(() => {
  const element = document.getElementById("lisa-product-jsonld");
  if (!element) return;

  let original;
  try {
    original = JSON.parse(element.textContent);
  } catch {
    return;
  }
  if (original["@type"] !== "Product" || !original.offers?.url) return;

  const originalText = JSON.stringify(original);
  const baseUrl = new URL(original.offers.url, document.baseURI);
  const listeners = new Map();

  const update = (variant) => {
    const schema = JSON.parse(originalText);
    if (!variant || !variant.id || typeof variant.available !== "boolean") {
      delete schema.offers;
      delete schema.sku;
      element.dataset.variantId = "";
    } else {
      const price = Number(variant.price);
      if (!Number.isFinite(price) || price < 0) return;
      const url = new URL(baseUrl);
      url.searchParams.set("variant", String(variant.id));
      schema.sku = variant.sku || "";
      schema.offers.url = url.href;
      schema.offers.price = (price / 100).toFixed(2);
      schema.offers.availability = variant.available
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock";
      element.dataset.variantId = String(variant.id);
    }
    element.textContent = JSON.stringify(schema, null, 2).replace(/</g, "\\u003c");
  };

  const bind = () => {
    const roots = document.querySelectorAll(".product-page--root product-options-root");
    for (const root of roots) {
      if (root.dataset.handle !== element.dataset.productHandle || !root.dataset.id) continue;
      const eventName = `theme:product:${root.dataset.id}:variantChanged`;
      if (listeners.has(eventName)) continue;

      const data = root.querySelector('script[id^="variant--json-"]');
      let variants;
      try {
        variants = JSON.parse(data?.textContent || "[]");
      } catch {
        continue;
      }
      if (!Array.isArray(variants) || !variants.length) continue;
      const byId = new Map(variants.map((variant) => [String(variant.id), variant]));
      const listener = (event) => {
        const variant = event.detail?.variant;
        if (variant && !byId.has(String(variant.id))) return;
        update(variant ? byId.get(String(variant.id)) : null);
      };
      listeners.set(eventName, listener);
      window.addEventListener(eventName, listener);
      const initial = byId.get(element.dataset.variantId);
      if (initial) update(initial);
    }
  };

  window.addEventListener("theme:loaded", bind);
  document.addEventListener("shopify:section:load", bind);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind, { once: true });
  } else {
    bind();
  }
})();
